import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ScheduleIcon from '@material-ui/icons/Schedule';
import moment from 'moment';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '../../../components/ConfirmDialog/ConfirmDialog';
import Api from '../../../Api';

const ReportFileItem = ({ file, fileDeleted, logedUser }) => {
  const { enqueueSnackbar } = useSnackbar();
  const fileURL = file.url;
  const [confirmDeleteDialogVisibility, setConfirmDeleteDialogVisibility] = useState(false);

  const viewerName = view => {
    if (view.user) {
      var fullName = [view.user.firstName, view.user.lastName].filter(Boolean).join(' ');
      if (fullName) {
        return fullName;
      }
      return view.user.email || 'Usuario';
    }
    return 'Usuario';
  };

  // El driver mysql2 (DB_TIMEZONE=-03:00) le aplica un offset extra a los
  // CURRENT_TIMESTAMP que ya vienen en UTC, dando +3h. Compensamos -3h para
  // mostrar la hora real de Argentina (workaround acotado a esta vista).
  const formatViewedOn = viewedOn => {
    if (!viewedOn) {
      return '';
    }
    return moment.utc(viewedOn).subtract(3, 'hours').local().format('DD/MM/YYYY HH:mm');
  };

  const isAdmin = logedUser && logedUser.u_role_id !== 3;
  const isClient = logedUser && logedUser.u_role_id === 3;
  const hasViews = file.views && file.views.length > 0;
  const viewedByMe = file.views && file.views.some(v => Number(v.user_id) === Number(logedUser.u_id));

  const handleOpenFile = () => {
    window.open(fileURL, '_blank');
  };

  const handleDeleteFile = async event => {
    event.preventDefault();
    event.stopPropagation();
    setConfirmDeleteDialogVisibility(true);
  };

  const handleCloseConfirmDeleteDialog = () => {
    setConfirmDeleteDialogVisibility(false);
  };

  const handleOnConfirmDelete = () => {
    setConfirmDeleteDialogVisibility(false);
    handleDeleteReportFile();
  };

  const handleDeleteReportFile = () => {
    Api.delete('/reports_files/' + file.id)
      .then(function() {
        fileDeleted();
        enqueueSnackbar('Archivo "' + file.name + '" removido exitosamente!', {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          variant: 'success'
        });
      })
      .catch(function(error) {
        var message = 'Error de conexion, contacta a soporte';
        if (error.response) {
          message = 'Ocurrio un error, intenta nuevamente.';
        }
        enqueueSnackbar(message, {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          variant: 'error'
        });
        return false;
      });
  };

  return (
    <div>
      <ListItem key={file.id} button onClick={handleOpenFile} style={{ textAlign: 'center' }}>
        <ListItemIcon>
          <CloudDownloadIcon />
        </ListItemIcon>
        <ListItemText primary={file.name} />
        {isAdmin ? (
          hasViews ? (
            <Tooltip
              title={
                <div>
                  {file.views.map((view, i) => (
                    <div key={i}>
                      Visto por {viewerName(view)} - {formatViewedOn(view.viewed_on)}
                    </div>
                  ))}
                </div>
              }>
              <CheckCircleIcon style={{ color: '#29b6f6', marginRight: 8 }} />
            </Tooltip>
          ) : (
            <Tooltip title="No visualizado">
              <ScheduleIcon style={{ color: '#9e9e9e', marginRight: 8 }} />
            </Tooltip>
          )
        ) : isClient ? (
          viewedByMe ? (
            <Tooltip title="Ya visto">
              <CheckCircleIcon style={{ color: '#29b6f6', marginRight: 8 }} />
            </Tooltip>
          ) : (
            <Chip label="NUEVO" size="small" style={{ marginRight: 8, backgroundColor: '#fb8c00', color: '#fff', fontWeight: 600 }} />
          )
        ) : null}
        <Button onClick={handleDeleteFile} style={{ color: '#e91e63' }}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
        </Button>
      </ListItem>
      <ConfirmDialog
        handleClose={handleCloseConfirmDeleteDialog}
        handleOnConfirm={handleOnConfirmDelete}
        visibility={confirmDeleteDialogVisibility}
        title="¿Está seguro que desea eliminar este archivo?"
        message="La eliminación de este archivo es permanente"
      />
    </div>
  );
};

export default ReportFileItem;
